import Vue from "vue";

import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

import Vue2TouchEvents from "vue2-touch-events";
Vue.use(Vue2TouchEvents);

import { translations } from "./assets/locales/translations";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueSegmentAnalytics from "vue-segment-analytics";
Vue.use(VueSegmentAnalytics, {
  id: process.env.VUE_APP_SEGMENT_ID,
  router, // Optional
});

import VueDrift from "vue-drift";
Vue.use(VueDrift, {
  appId: "xxygxuscaepz",
});

import VModal from "vue-js-modal";
Vue.use(VModal);

import App from "./App.vue";
import router from "./router";

import "@/assets/scss/style.scss";

Vue.config.productionTip = false;

// Ready translated locale messages
const messages = translations;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "de", // set locale
  messages: messages, // set locale messages
});

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
